import React from 'react'

import FormManager from "../../../../../gd-form/common/form-manager"
import Textarea from "../../../../../gd-form/form-element/textarea/textarea"

type Props = {
    form    : FormManager
}

export default function ProjectForm_Description(props: Props) {
    return (
        <div className="row">
            <div className="label">Description</div>
            <div className="element">
                <Textarea className = "w-300"
                          size      = "2-rows"
                          rows      = {2}
                          form      = {props.form}
                          name      = "description"/>
            </div>
        </div>
    )
}
